'use strict';

// TODO: @deprecated http://www.w3schools.com/jsref/jsref_escape.asp
declare var escape;

export class Cookies {
    getCookie(name) {
        var cookie = new RegExp(name + '=([^;]+)').exec(document.cookie);
        if (!cookie) {
            return '';
        }
        var value = cookie[1];
        if (value[0] === "\"" && value[value.length - 1] === "\"") {
            return value.substring(1, value.length - 1);
        }
        return value;
    }

    setPermanentCookie(name, value) {
        var expires = new Date();
        expires.setFullYear(expires.getFullYear() + 100);
        document.cookie = escape(name) + '=' + escape(value) + '; expires=' + expires.toUTCString() + '; path=/';
    };

    expireCookie(name) {
        document.cookie = escape(name) + '=; expires=' + new Date() + '; path=/';
    }
}


// WEBPACK FOOTER //
// ./src/main/ui/core/application/Cookies.ts